import React, { useEffect } from 'react';
import useStateRef from 'react-usestateref';
import BreadCrumbsContainer from '../BreadCrumbs/BreadCrumbsContainer';
import MyAccountCommonize from './MyAccountCommonize';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';

const MyOrganization = ({ containerObject, templateName, contentId, dataZone }) => {
    const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)
    const [organizationDetail, setOrganizationDetail, organizationDetailRef] = useStateRef('')
    function handlePrintPage() {
        window.print()
    }
    const history = useHistory()

    useEffect(() => {
        var searchParam = window.location.search
        var uri = searchParam.split("?")
        if (profileDetails && profileDetails.transient && uri && uri != null && uri.length > 0 && uri[1] != "DPSLogout=true") {
            history.push("/account/login?resume=prev")
        }
    }, [profileDetails])
    useEffect(() => {
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/organization-details`, {
            method: 'GET'
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    //setIsLoading(false)
                    setOrganizationDetail(res.response)
                    //window.location.href = "/"
                    //setProfileDetail(res.response)
                } else {
                    // setIsLoading(false)
                    const error = res._ERROR_MESSAGE_;
                    // setErrorMessage(error);
                    //document.getElementById("login-message-error-div").classList.remove("d-none");

                }
            })
    }, [])

    //breadcrumbs object 
    const breadCrumbs = {
        "ancestors": [
            {
                label: "My Account",
                link: "/account/landing"
            }, {
                label: "My Organization",
                link: "/account/b2i/organization-user"
            }
        ],
        productName: ""
    };

    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail`}>
            {profileDetails && !profileDetails.transient ?
                <>
                    <div className="row align-items-center mx-1 justify-content-between c-breadcrumb-custom">
                        <div className="row col-md-11">
                            <BreadCrumbsContainer breadCrumbs={breadCrumbs} pageType="MyOrganization"></BreadCrumbsContainer>
                        </div>
                        <div className="col-12 col-md-1 d-none d-lg-block">
                            <button className="btn btn-light c-print-btn text-end" type="button" onClick={handlePrintPage}>
                                <i className="fas fa-print" ></i>Print
                            </button>
                        </div>

                    </div>
                    <div className="row page-min-height gx-0 c-shopping-list-item-padding">
                        <MyAccountCommonize />

                        <div className="col-lg-9 col-lg-9 c-shopping-list-item-col c-my-profile-details">
                            <h1 className="right-panel-heading">My Organization</h1>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <p className="my-org-label">Carolina Account Number:</p>
                                        </div>

                                        <div className="col-md-8">
                                            <p className="my-org-info">
                                                {organizationDetailRef.current && organizationDetailRef.current.carolinaAccountNumber ? organizationDetailRef.current.carolinaAccountNumber : ""}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row"><div className="col-md-4"><p className="my-org-label">Billing Address:</p></div>
                                        <div className="col-md-8">
                                            {organizationDetailRef.current && organizationDetailRef.current.billingAddress ?
                                                <address>
                                                    {organizationDetailRef.current.billingAddress.companyName}<br />{organizationDetailRef.current.billingAddress.addr1}<br />{organizationDetailRef.current.billingAddress.addr2}<br />{organizationDetailRef.current.billingAddress.city}, {organizationDetailRef.current.billingAddress.state} {organizationDetailRef.current.billingAddress.zip}<br />
                                                </address>
                                                : ""}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4"><p className="my-org-label">Contract Terms:</p></div>
                                        <div className="col-md-8" dangerouslySetInnerHTML={{ __html: organizationDetailRef.current && organizationDetailRef.current.contractTermsMessage ? organizationDetailRef.current.contractTermsMessage : "" }}>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <strong> */}
                                <hr />
                                <strong><h1 className="right-panel-heading">My Settings</h1></strong>
                                <p className='my-org-setting' dangerouslySetInnerHTML={{ __html: organizationDetailRef.current && organizationDetailRef.current.mySettingsMessage ? organizationDetailRef.current.mySettingsMessage : "" }}></p>
                            {/* </strong> */}

                            {organizationDetailRef?.current?.mySettingsMessage && <p></p>}
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row"> <div className="col-md-4"><p className="my-org-label">Tax Exempt:</p></div>
                                        <div className="col-md-8">
                                            <p className="my-org-info">
                                                {organizationDetailRef.current && organizationDetailRef.current.isTaxExempt ? organizationDetailRef.current.isTaxExempt : ""}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row"><div className="col-md-4"><p className="my-org-label">Online Purchase Orders:</p></div>
                                        <div className="col-md-8">
                                            <p className="my-org-info">
                                                {organizationDetailRef.current && organizationDetailRef.current.isPoEligible ? organizationDetailRef.current.isPoEligible : ""}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row"><div className="col-md-4"><p className="my-org-label">Spending Limit:</p></div>
                                        <div className="col-md-8">

                                            <p className="my-org-info">
                                                {organizationDetailRef.current && organizationDetailRef.current.spendingLimit ? organizationDetailRef.current.spendingLimit : ""}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div></>
                : ""}
        </div>
    );
};

export default MyOrganization;
